import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPaymentPayoutDetails = paymentId =>
  call(websocketFetch, 'get_payment_payout_details', {
    payment_id: paymentId,
  });
